import { Fragment, type PropsWithChildren, useContext } from "react";
import flex from "../../../../styles/flex";
import fonts from "../../../../styles/fonts";
import { EditableGroupContext } from "../../EditableGroup/EditableGroup";
import styles from "../styles";

interface FieldLabelProps {
    alwaysVisible?: boolean
}

const FieldLabel = (props: PropsWithChildren<FieldLabelProps>) => {
    const state = useContext(EditableGroupContext);
    if (state.isEditing != true || props.alwaysVisible == true) {
        return <div style={flex.flexFill}>
            <span style={fonts.small}>
                <div style={styles.paddingLabel}>{props.children}</div>
            </span></div>
    }
    return <Fragment />
}

export default FieldLabel;